import { AppSportsBookState } from 'src/domains/sportsbook/state/AppSportsBook.state';
import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { EventCard } from 'src/domains/sportsbook/webview/components/eventCard/EventCard';
import { CarouselEventNavigation } from 'src/domains/layouts/webview/components/eventNavigation/CarouselEventNavigation';
import { LayoutSkeleton } from 'src/domains/layouts/webview/modules/LayoutSkeleton';
import { PriceChangeLegend } from 'src/domains/layouts/webview/components/priceChangeLegend/PriceChangeLegend';
import { EventRouteType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { RightHandSideViewType } from 'src/domains/layouts/state/router/newRouter/rhsRouteType';
import { Wrapper, Event } from './EventPage.style';
import {
    BackButton,
    EventNavigation,
} from 'src/domains/layouts/webview/components/eventNavigation/CarouselSelection.style';
import { useCommon } from 'src/domains/common/Common';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { SportsNavigation } from 'src/domains/layouts/webview/components/eventNavigation/SportsNavigation';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
interface EventLayoutPropsType {
    currentView: EventRouteType;
    isSearchActive: boolean;
    accountView: RightHandSideViewType | null;
    isNotificationsList: boolean;
}

export const EventLayout = observer('EventLayout', (props: EventLayoutPropsType) => {
    const { currentView, accountView, isSearchActive, isNotificationsList } = props;

    const common = useCommon();
    const appSportsBookState = AppSportsBookState.get(common);
    const {
        componentVariants: { sportsbookVariant },
        unifiedSportEventsTable,
    } = ConfigComponents.get(common).unifiedComponentConfig;

    const { models } = appSportsBookState;

    const currentViewId = models.id.getEventId(currentView.id);
    const actualEvent = currentViewId.getEventModel();
    const isRacing = actualEvent === null ? false : ['greyhoundracing', 'horseracing'].includes(actualEvent.sport);
    // This feature is currently not being used
    // const { isAlternativeEvent } = appSportsBookState.alternativeEventState.get(currentViewId);

    // if (isAlternativeEvent) {
    //     return (
    //         <Event>
    //             <LayoutSkeleton
    //                 currentView={currentView}
    //                 accountView={accountView}
    //                 isSearchActive={isSearchActive}
    //                 navigationType='global'
    //             >
    //                 <Wrapper variant={sportsbookVariant}>
    //                     <AlternativeEvent currentView={currentView} />
    //                 </Wrapper>
    //             </LayoutSkeleton>
    //         </Event>
    //     );
    // }

    const renderEventPageNavigation = (currentView: EventRouteType): React.ReactNode => {
        const starRouter = StarRouter.get(common);

        if (actualEvent === null) {
            return null;
        }

        if (unifiedSportEventsTable) {
            return <SportsNavigation currentView={currentView} />;
        }

        const handleRedirectToCompetitionPage = (): void => {
            starRouter.redirectToPreviousPage(() => {
                starRouter.redirectToCompetitionPage(actualEvent.competition, actualEvent.sport);
            });
        };

        return (
            <EventNavigation>
                <BackButton
                    onClick={handleRedirectToCompetitionPage}
                    position='left'
                />

                <CarouselEventNavigation currentView={currentView} />
            </EventNavigation>
        );
    };

    return (
        <Event>
            <LayoutSkeleton
                currentView={currentView}
                accountView={accountView}
                isSearchActive={isSearchActive}
                navigationType='global'
            >
                <Wrapper variant={sportsbookVariant}>
                    {isRacing !== true && renderEventPageNavigation(currentView)}
                    <EventCard
                        eventId={appSportsBookState.models.id.getEventId(currentView.id)}
                        isNotificationsList={isNotificationsList}
                    />
                    {isRacing === true ? <PriceChangeLegend isRace={false} /> : null}
                </Wrapper>
            </LayoutSkeleton>
        </Event>
    );
});
